import GetCompanyRequestModelBase from '../_generated/modelBases/get-company-request-model-base';

export default class GetCompanyRequestModel extends GetCompanyRequestModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
